<template>
  <v-card>
    <v-card-title class="pb-0">User Count {{ activePastMonth ? "(Monthly)" : "" }}</v-card-title>
    <div class="user-count">{{ userCount }}</div>
  </v-card>
</template>

<script>
export default {
  name: "user-count.vue",

  props: {
    activePastMonth: Boolean,
  },

  data: function () {
    return {
      userCount: undefined,
    };
  },

  async mounted() {
    this.userCount = await this.getUserCount();
  },

  methods: {
    async getUserCount() {
      let params = {};
      if (this.activePastMonth) {
        let onlineSince = new Date();
        onlineSince.setDate(onlineSince.getDate() - 31);
        params.minLastOnline = onlineSince.toISOString();
      }

      const response = await this.$axios.get("v1/analytics/user-count", { params });
      return response.data.userCount;
    },
  },
};
</script>

<style scoped>
.user-count {
  text-align: center;
  font-size: 56px;
  font-weight: bold;
}
</style>
